import React, { useState } from 'react';
import { FiSearch, FiX, FiPlus, FiList, FiUser } from 'react-icons/fi';
import { FaUmbrellaBeach } from 'react-icons/fa';
import HRMSidebar from '../components/HRMSidebar';
import GenericAddModal from '../components/GenericAddModal';
import useLocalState from '../hooks/useLocalState';
import { sortData, getNextStatus } from '../utils/tableUtils';

const initialData = [
  { ref: 'HL2602-0007', emp: 'Wan Yee Lui', app: 'Wan Yee Lui', type: 'Other leave', days: '1 days', start: '02/25/2026', startD: '(Morning)', end: '02/25/2026', endD: '(Afternoon)', val: '03/06/2026', status: 'Approved' },
  { ref: 'HL2602-0006', emp: 'Wan Yee Lui', app: 'Wan Yee Lui', type: 'Other leave', days: '2 days', start: '02/03/2026', startD: '(Morning)', end: '02/04/2026', endD: '(Afternoon)', val: '03/06/2026', status: 'Approved' },
  { ref: 'HL2601-0005', emp: 'Wan Yee Lui', app: 'Wan Yee Lui', type: 'Other leave', days: '1 days', start: '01/19/2026', startD: '(Morning)', end: '01/19/2026', endD: '(Afternoon)', val: '03/06/2026', status: 'Approved' },
  { ref: 'HL2601-0004', emp: 'Wan Yee Lui', app: 'Wan Yee Lui', type: 'Other leave', days: '1 days', start: '01/02/2026', startD: '(Morning)', end: '01/02/2026', endD: '(Afternoon)', val: '03/06/2026', status: 'Approved' },
  { ref: 'HL2512-0002', emp: 'Wan Yee Lui', app: 'Wan Yee Lui', type: 'Other leave', days: '1 days', start: '12/09/2025', startD: '(Morning)', end: '12/09/2025', endD: '(Afternoon)', val: '03/05/2026', status: 'Approved' },
  { ref: 'HL2511-0003', emp: 'Wan Yee Lui', app: 'Wan Yee Lui', type: 'Other leave', days: '2 days', start: '11/18/2025', startD: '(Morning)', end: '11/19/2025', endD: '(Afternoon)', val: '03/05/2026', status: 'Approved' },
  { ref: 'HL2502-0001', emp: 'Wan Yee Lui', app: 'Wan Yee Lui', type: 'Other leave', days: '260 days', start: '02/04/2025', startD: '(Morning)', end: '02/07/2026', endD: '(Afternoon)', val: '', status: 'Refused' },
];

export default function LeaveList() {
  const [data, setData] = useLocalState('leave_data_v2', initialData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'start', direction: 'desc' });

  const handleAdd = (newData) => {
    setData([
      { ...newData, status: newData.status || 'Pending', startD: '(Morning)', endD: '(Afternoon)' },
      ...data
    ]);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortConfig({ key, direction });
  };

  const handleStatusChange = (rowToUpdate) => {
    const nextStatus = getNextStatus(rowToUpdate.status, ['Pending', 'Approved', 'Refused']);
    setData(data.map(row => row === rowToUpdate ? { ...row, status: nextStatus } : row));
  };

  const sortedData = sortData(data, sortConfig);

  const SortIcon = ({ column }) => {
    if (sortConfig.key !== column) return <span className="text-[10px] text-gray-400 opacity-0 group-hover:opacity-100 ml-1">▲</span>;
    return <span className="text-[10px] text-black ml-1">{sortConfig.direction === 'asc' ? '▲' : '▼'}</span>;
  };

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <HRMSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-center mb-3 px-1 text-gray-800">
          <div className="flex items-center space-x-2 text-teal-800">
            <FaUmbrellaBeach className="text-xl text-[#8b4513]" />
            <span className="font-medium text-[15px]">List of leave ({data.length})</span>
          </div>
          <div className="flex items-center space-x-2">
            <select className="border border-gray-400 bg-white py-1 px-2 text-sm rounded-sm outline-none w-16">
              <option>20</option>
            </select>
            <button onClick={() => setIsModalOpen(true)} className="bg-[#0000a0] text-white p-1.5 rounded shadow-sm hover:bg-blue-900 transition-colors">
              <FiPlus className="text-lg font-bold" />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-x-auto bg-white border border-gray-800 shadow-sm">
          <table className="min-w-full border-collapse text-[13px] text-gray-800">
            <thead>
              <tr className="bg-white">
                <td className="border border-gray-800 p-1 w-32"></td>
                <td className="border border-gray-800 p-1 w-40"><select className="w-full border border-gray-300 p-1 bg-[#a6e4e7] outline-none h-7"><option></option></select></td>
                <td className="border border-gray-800 p-1 w-40"><select className="w-full border border-gray-300 p-1 bg-[#a6e4e7] outline-none h-7"><option></option></select></td>
                <td className="border border-gray-800 p-1 w-36"><select className="w-full border border-gray-300 p-1 bg-[#a6e4e7] outline-none h-7"><option></option></select></td>
                <td className="border border-gray-800 p-1 w-24"></td>
                <td className="border border-gray-800 p-1 w-32"><input type="text" className="w-full border border-gray-300 p-1 bg-[#a6e4e7] outline-none h-7" /></td>
                <td className="border border-gray-800 p-1 w-32"><input type="text" className="w-full border border-gray-300 p-1 bg-[#a6e4e7] outline-none h-7" /></td>
                <td className="border border-gray-800 p-1 w-32"><input type="text" className="w-full border border-gray-300 p-1 bg-[#a6e4e7] outline-none h-7" /></td>
                <td className="border border-gray-800 p-1 w-28"><select className="w-full border border-gray-300 p-1 bg-[#a6e4e7] outline-none h-7"><option></option></select></td>
                <td colSpan="2" className="border border-gray-800 p-1 bg-gray-100 text-center w-16">
                  <div className="flex justify-center space-x-3 text-lg font-bold">
                    <FiSearch className="text-black cursor-pointer hover:opacity-70" />
                    <FiX className="text-black cursor-pointer hover:opacity-70" />
                  </div>
                </td>
              </tr>
              <tr className="bg-[#a6e4e7] text-teal-900 select-none">
                <th onClick={() => handleSort('ref')} className="font-normal p-2.5 border border-gray-800 text-left text-[12px] text-teal-800 cursor-pointer hover:bg-teal-200 group">Ref. <SortIcon column="ref" /></th>
                <th onClick={() => handleSort('emp')} className="font-normal p-2.5 border border-gray-800 text-left text-[12px] text-teal-800 cursor-pointer hover:bg-teal-200 group">Employee <SortIcon column="emp" /></th>
                <th onClick={() => handleSort('app')} className="font-normal p-2.5 border border-gray-800 text-left text-[12px] text-teal-800 cursor-pointer hover:bg-teal-200 group">Approver <SortIcon column="app" /></th>
                <th className="font-normal p-2.5 border border-gray-800 text-left text-[12px] text-teal-800">Type</th>
                <th onClick={() => handleSort('days')} className="font-normal p-2.5 border border-gray-800 text-center text-[12px] text-teal-800 leading-tight cursor-pointer hover:bg-teal-200 group">Days of<br/>leave <SortIcon column="days" /></th>
                <th onClick={() => handleSort('start')} className="font-normal p-2.5 border border-gray-800 text-center text-[12px] text-teal-800 cursor-pointer hover:bg-teal-200 group">Start date <SortIcon column="start" /></th>
                <th onClick={() => handleSort('end')} className="font-normal p-2.5 border border-gray-800 text-center text-[12px] text-teal-800 cursor-pointer hover:bg-teal-200 group">End date <SortIcon column="end" /></th>
                <th className="font-normal p-2.5 border border-gray-800 text-center text-[12px] text-teal-800">Validation ...</th>
                <th onClick={() => handleSort('status')} className="font-normal p-2.5 border border-gray-800 text-right text-[12px] text-teal-800 cursor-pointer hover:bg-teal-200 group">Status <SortIcon column="status" /></th>
                <th className="font-normal p-2.5 border border-gray-800 text-center text-[12px] text-teal-800"><FiList className="inline" /></th>
                <th className="font-normal p-2.5 border border-gray-800 text-center"><input type="checkbox" className="w-3.5 h-3.5 accent-[#0000a0]" /></th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, idx) => (
                <tr key={idx} className="bg-white hover:bg-blue-50 transition-colors">
                  <td className="p-2 border border-gray-800 text-gray-800 whitespace-nowrap">
                    <FaUmbrellaBeach className="inline mr-1.5 text-[#8b4513]" /> {row.ref}
                  </td>
                  <td className="p-2 border border-gray-800 text-teal-800 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="w-5 h-5 rounded-full bg-[#5bc0be] text-white flex items-center justify-center mr-1.5">
                        <FiUser className="text-[11px]" />
                      </div>
                      {row.emp}
                    </div>
                  </td>
                  <td className="p-2 border border-gray-800 text-teal-800 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="w-5 h-5 rounded-full bg-[#5bc0be] text-white flex items-center justify-center mr-1.5">
                        <FiUser className="text-[11px]" />
                      </div>
                      {row.app}
                    </div>
                  </td>
                  <td className="p-2 border border-gray-800 text-gray-800">{row.type}</td>
                  <td className="p-2 border border-gray-800 text-right pr-6 text-gray-800">{row.days}</td>
                  <td className="p-2 border border-gray-800 text-center leading-tight">
                    <div className="text-gray-800">{row.start}</div>
                    <div className="text-gray-400 text-[11px]">{row.startD}</div>
                  </td>
                  <td className="p-2 border border-gray-800 text-center leading-tight">
                    <div className="text-gray-800">{row.end}</div>
                    <div className="text-gray-400 text-[11px]">{row.endD}</div>
                  </td>
                  <td className="p-2 border border-gray-800 text-center text-gray-800">{row.val}</td>
                  <td className="p-2 border border-gray-800 text-right">
                    <span onClick={() => handleStatusChange(row)} className={`cursor-pointer px-2 py-0.5 rounded-[3px] text-[11px] font-medium border transition-colors ${
                      row.status === 'Approved' ? 'bg-gray-200 text-gray-600 border-gray-300 hover:bg-gray-300' : 
                      row.status === 'Refused' ? 'bg-[#fff1f0] text-[#ff0000] border-[#ffa39e] hover:bg-[#ffccc7]' : 
                      'bg-white text-gray-400 border-gray-300 hover:bg-gray-50'
                    }`}>
                      {row.status}
                    </span>
                  </td>
                  <td className="p-2 border border-gray-800 text-center"></td>
                  <td className="p-2 border border-gray-800 text-center"><input type="checkbox" className="w-3.5 h-3.5 accent-[#0000a0]" /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <GenericAddModal 
          isOpen={isModalOpen} 
          onClose={() => setIsModalOpen(false)} 
          onAdd={handleAdd} 
          title="Add Leave Request" 
          fields={[
            { name: 'ref', label: 'Reference (e.g. HL2603-0008)' },
            { name: 'emp', label: 'Employee Name' },
            { name: 'type', label: 'Leave Type' },
            { name: 'days', label: 'Days of leave' },
            { name: 'start', label: 'Start Date (MM/DD/YYYY)' },
            { name: 'end', label: 'End Date (MM/DD/YYYY)' }
          ]} 
        />
      </div>
    </div>
  );
}